<template>
  <BaseView>
    <template #header>
      <SearchAreaComponent />
    </template>

    <template #content>
      <EmptyAreas
        v-if="fetchRequestFailed"
        message="Could not fetch areas"
      />
      <EmptyAreas
        v-else-if="noAreas && !fetchLoading"
        message="No areas found"
      />
      <CustomAreasLoading v-else-if="fetchLoading" />
      <CustomAreasSuccess v-else />
    </template>

    <template #action>
      <CustomThemedButton
        rounded
        block
        class="main-button"
        @click="onCreateAreaPressed"
      >
        Create Area
      </CustomThemedButton>
    </template>
  </BaseView>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import EmptyAreas from "./components/EmptyList.vue";
import CustomAreasLoading from "./LoadingView.vue";
import CustomAreasSuccess from "./SuccessView.vue";
import SearchAreaComponent from "./components/SearchArea.vue";
import BaseView from "../../components/BaseView.vue";
import CustomThemedButton from "@/core/CustomThemedButton.vue";
export default {
  components: {
    EmptyAreas,
    CustomAreasLoading,
    CustomAreasSuccess,
    BaseView,
    SearchAreaComponent,
    CustomThemedButton,
  },
  computed: {
    ...mapState("weatherRouting/customAreasModule", [
      "fetchLoading",
      "fetchError",
    ]),
    ...mapGetters("weatherRouting/customAreasModule", [
      "fetchRequestFailed",
      "noAreas",
    ]),
  },
  methods: {
    onCreateAreaPressed() {
      this.$router.push({
        name: "Create Area",
      });
      this.$store.commit(
        "weatherRouting/customAreasModule/SET_SELECTED_AREA",
        null
      );
    },
  },
};
</script>

<style scoped>
.main-button {
  background-color: var(--color-secondary) !important;
  color: var(--color-text) !important;
}
</style>
